module.exports = __webpack_public_path__ + "static/media/dice-throw.d9b69d71.png";